<template>
    <div class="lot" v-if="lot">
        <div class="lot__main">
            <div class="lot__top">
                <div class="lot__name">
                    <span class="lot__number">ЛОТ {{ lot.id }}:</span> {{ lot.title }}
                </div>
                <div class="lot__tags">
                    <template v-for="category in lot.lot_categories">{{ category.title }},</template>
                    {{ lot.office.city.title }}, Офис продаж: <a href="#">{{ lot.office.branch_name }}</a>
                </div>
                <div class="lot__top-info" v-if="windowWidth < 1170">
                    <!--<div class="lot__info-item"  v-if="!lot.deleted_at">
                        <span class="lot__info-name">Текущая цена</span>
                        <span class="lot__price">{{ lot.last_price ? Number(lot.last_price).toLocaleString('ru') : Number(lot.original_price).toLocaleString('ru') }} ₽</span>
                    </div>-->
                    <div class="auction__info-item" v-if="lot.deleted_at && lot.last_price > 0">
                        <span class="auction__info-name">Выигрышная ставка</span>
                        <span class="auction__price">{{ Number(lot.last_price).toLocaleString('ru')}} ₽</span>
                    </div>
                    <div class="lot__info-item" v-if="!lot.deleted_at">
                        <span class="lot__info-name" v-if="checkBeforeNowDate(lot.start_auction)">Идут торги</span>
                        <span class="lot__info-name" v-else>Ожидает торгов</span>
                       <!-- <span class="lot__info-name" v-if="checkBeforeNowDate(lot.start_auction)">До конца торгов</span>
                        <span class="lot__info-name" v-else>До начала торгов</span>
                        <countdown class="lot__time" :time="lot.countdown" :transform="transform">
                            <template slot-scope="props">
                                <template v-if="props.days !== '00'">
                                    <span class="auction__time-item">{{ props.days }}</span>д
                                </template>
                                <span class="lot__time-item">{{ props.hours }}</span> :
                                <span class="lot__time-item">{{ props.minutes }}</span>
                                <template v-if="props.days === '00'">
                                    : <span class="auction__time-item">{{ props.seconds }}</span>
                                </template>
                            </template>
                        </countdown>-->
                    </div>
                    <div class="auction__info-item" v-else>
                        <span class="auction__info-name">Торги завершены</span>
                    </div>
                </div>
            </div>
            <vue-gallery-slideshow :images="lot.photos" :index="image" @close="image = null"></vue-gallery-slideshow>
            <div class="lot__images">
                <div class="lot__main-img" :style="'background-image: url('+ lot.photos[0] + ');' " @click="image = 0" />
                <div class="lot__images-box n-scroll" :style="windowWidth - 20 > 82 * lot.photos.slice(1).length && windowWidth < 1170 ? 'justify-content: center;' : ''">
                    <div class="lot__img" v-for="(item, i) in lot.photos.slice(1)" :key="i" @click="image = (i + 1)" :style="'background-image: url('+ item + ');' " />
                    <button class="btn lot__scroll" @click="imagesScroll()" v-if="(windowWidth >= 1170 && lot.photos.slice(1).length > 2) || (windowWidth - 20 < 82 * lot.photos.slice(1).length && windowWidth < 1170)" />
                </div>
            </div>
            <mobile-lot v-if="windowWidth < 1170"></mobile-lot>
            <div class="lot__description" v-html="textFormat(lot.description)"></div>
        </div>
        <desktop-lot v-if="windowWidth >= 1170"></desktop-lot>
    </div>
</template>

<script>
import VueGallerySlideshow from 'vue-gallery-slideshow';
import {mapState} from 'vuex';
import {store} from "../../store/lot";
import style from "../../mixins/style";
import MobileLot from "./modules/mobileLot";
import DesktopLot from "./modules/desktopLot";

export default {
    name: "Lot",
    store,
    mixins: [style],
    components: {
        DesktopLot,
        MobileLot,
        VueGallerySlideshow
    },
    computed: {
        ...mapState([
            'lot',
        ]),
    },
    data: () => ({
        image: null,
    }),

    methods: {
        imagesScroll() {
            if (this.windowWidth >= 1170) {
                document.querySelector('.lot__images-box').scrollTop = document.querySelector('.lot__images-box').scrollHeight;
            } else {
                document.querySelector('.lot__images-box').scrollLeft = document.querySelector('.lot__images-box').scrollWidth;
            }
        }
    }
}
</script>
